// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clock-item[data-v-d7f7d564] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 70%;\n  border: 1px solid #ededed;\n  margin-bottom: 12px;\n  padding: 20px;\n  border-radius: 4px;\n}\n.icon-delete[data-v-d7f7d564] {\n  color: red;\n}\n.margin-left[data-v-d7f7d564] {\n  margin-left: 8px;\n}\n.margin-right[data-v-d7f7d564] {\n  margin-right: 6px;\n}\n.margin-top[data-v-d7f7d564] {\n  margin-top: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
